export class Contact {
    id: string;
    name: string;
    email: string;
    phone?: string;
    message: string;
}
